import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    formData.delete('phone_alt');

    setStatus('loading');

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d9s8o6nnahb7382ovs80',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(
            Array.from(formData.entries()).map(([k, v]) => [k, String(v)])
          ).toString(),
        }
      );

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (
        response.ok &&
        parsed?.code === 'OK'
      ) {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们会定期为你推送温暖的故事。');
        setEmail('');
      } else {
        const isSpam =
          typeof serverMsg === 'string' &&
          (serverMsg.includes('spam') || serverMsg.includes('form data is spam'));
        if (isSpam) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(
            typeof serverMsg === 'string' && serverMsg.length > 0
              ? serverMsg
              : '提交失败，请稍后再试。'
          );
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="mt-5 font-heading text-2xl md:text-3xl text-foreground-950">
          订阅我们的故事
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto">
          每周为你推送一篇温暖的故事，陪伴你度过每一个平凡而珍贵的日子。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-md mx-auto"
        >
          <div className="visually-hidden-field">
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 text-sm bg-background-50 border border-background-300/60 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all duration-200 text-foreground-950 placeholder:text-foreground-400"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-primary-500 text-white rounded-full font-label text-sm hover:bg-primary-600 transition-colors duration-200 disabled:opacity-60 cursor-pointer whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : '订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-3 text-sm text-secondary-700">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-3 text-sm text-primary-600">{message}</p>
        )}
      </div>
    </section>
  );
}